export const INTEGER_ONLY_REGEX = /^\d*$/; // Matches only integer digits (0-9), any length including empty string
export const PERCENT_ONLY_REGEX = /^\d*\.?\d*$/; // Matches valid percent (digits, optional decimal point, digits), e.g. '12.34'
export const TRAILING_ZEROS_REGEX = /0+$/;
export const STRICT_INTEGER_ONLY_REGEX = /^\d*\.?\d+$/;
